import { useState, useEffect } from "react";
import HolidaysTable from "../../elements/HolidaysTable";
import axiosInstance from "../../../services/axios-instance";
import { HOLIDAYS_URL } from "../../../services/endpoints";
import { AllHolidaysInterface } from "../../../interface/allHolidaysInterface";
import AddingHolidaysForm from "../../template/sidebar/AddingHolidaysForm";

const cellNames = {
    cellOne: "Name",
    cellTwo: "Email",
    cellTree: "Type",
    cellFour: "Description",
    cellFive: "From date",
    cellSix: "To date",
    cellSeven: "Holiday status",
    cellEight: "Accept",
    cellNine: "Decline",
};
const AdminManageHolidaysScreen = () => {
    const [allHolidays, setAllHolidays] = useState<AllHolidaysInterface[]>([]);

    useEffect(() => {
        async function fetchAllHolidaysData() {
            try {
                const responseAllHolidays = await axiosInstance.get(
                    HOLIDAYS_URL
                );
                setAllHolidays(responseAllHolidays.data.data);
            } catch (error) {
                console.error(error);
            }
        }
        fetchAllHolidaysData();
    }, []);

    return (
        <>
            <AddingHolidaysForm setAllHolidays={setAllHolidays} />
            <HolidaysTable
                cellNames={cellNames}
                data={allHolidays}
                setAllHolidays={setAllHolidays}
            />
        </>
    );
};

export default AdminManageHolidaysScreen;
